<template>
  <div>
    <div v-html="content"></div>
  </div>
</template>

<script>
export default {
  props: ["tableData", "scope"],
  data() {
    return {};
  },
  computed: {
    content() {
      return this.scope.row[this.tableData.bind]
    }
  },
  methods: {},
  components: {}
};
</script>

<style>
</style>
